import { useEffect, useState } from "react";

const useCsrfToken = () => {
  const [csrfToken, setCsrfToken] = useState('');

  useEffect(() => {
    setCsrfToken((document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '');
  }, []);

  return csrfToken;
};

export default useCsrfToken;
